import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FooterComponent, HeaderComponent } from '@imagise/widgets';
import { BidiModule } from '@angular/cdk/bidi';

@Component({
  imports: [
    RouterModule,
    HeaderComponent,
    FooterComponent,
    BidiModule,
  ],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {}
